import { createContext, useContext, type ReactNode } from "react";
import type { TenantView } from "@vereinfach/types";

const CurrentTenantContext = createContext<TenantView | null>(null);

/**
 * Exposes the tenant whose data the current dash view is looking at —
 * the impersonated tenant if the logged-in admin has picked one,
 * otherwise the user's own. Provided by DashLayout; consumed anywhere
 * below it that needs full tenant info (name, slug, entitlement, …)
 * instead of just the id returned by useTenantId.
 */
export function CurrentTenantProvider({
  tenant,
  children,
}: {
  tenant: TenantView;
  children: ReactNode;
}) {
  return <CurrentTenantContext.Provider value={tenant}>{children}</CurrentTenantContext.Provider>;
}

export function useCurrentTenant(): TenantView {
  const ctx = useContext(CurrentTenantContext);
  if (!ctx)
    throw new Error("useCurrentTenant must be used inside CurrentTenantProvider (DashLayout)");
  return ctx;
}
